import { TabSwitch, VStack } from '@genial/components';
import { useBreakpointValue } from '@genial/utils';
import { RouteProp, useRoute } from '@react-navigation/native';
import React, { useState } from 'react';

import { CustomerDetailTypes } from '../..';
import { useRecoilQuery } from '../../../../hooks/useRecoilQuery';
import { CustomerDetailStackParamList } from '../../../../routes/types';
import { customerDetailFullAccountDataQuery } from '../../../../store/customerDetail/selector';

import { ContainerFinancialData } from './components/ContainerFinancialData';
import { ContainerPersonalData } from './components/ContainerPersonalData';

export const Account: React.FC<CustomerDetailTypes.Props> = () => {
  const route = useRoute<RouteProp<CustomerDetailStackParamList, 'CustomerDetail'>>();

  const { data, error, loading, refresher } = useRecoilQuery(
    customerDetailFullAccountDataQuery({
      accountNumber: route.params.accountNumber,
    })
  );

  const tabs = [
    {
      key: 'financialData',
      label: 'Dados Financeiros',
      component: (
        <ContainerFinancialData
          isLoading={loading}
          hasError={!!error}
          onRefresh={refresher}
          customerDetailFull={data}
        />
      ),
    },
    {
      key: 'personalData',
      label: 'Dados Pessoais',
      component: (
        <ContainerPersonalData
          isLoading={loading}
          hasError={!!error}
          onRefresh={refresher}
          customerDetailFull={data}
        />
      ),
    },
  ];

  const [selectedTab, setSelectedTab] = useState(route.params.accountInitialTab ?? tabs[0].key);
  const isMobile = useBreakpointValue({
    base: true,
    sm: false,
  });

  return (
    <VStack flex={1}>
      <TabSwitch
        testId="tab-switch"
        tabs={tabs}
        selectedTab={selectedTab}
        onTabPress={setSelectedTab}
        isMobile={isMobile}
        isLoading={false}
      />
    </VStack>
  );
};
